import http from 'plugins/axios'

export default {
  // 活期
  fetchCurrentList(params) {
    return http.get({
      url: '/financial-admin/current/list',
      params,
    })
  },
  fetchCurrentSubmit(data) {
    return http.post({
      url: '/financial-admin/current/submit',
      data,
    })
  },
  fetchCurrentDetail(params) {
    return http.get({
      url: '/financial-admin/current/detail',
      params,
    })
  },
  fetchCurrentOrderList(params) {
    return http.get({
      url: '/financial-admin/current/order-list',
      params,
    })
  },
  fetchCurrentStatusSet(data) {
    return http.post({
      url: '/financial-admin/current/status-set',
      data,
    })
  },
  fetchCurrentSwitchConf() {
    return http.get({
      url: '/financial-admin/current/switch-conf',
    })
  },
  fetchCurrentSwitchSet(data) {
    return http.post({
      url: '/financial-admin/current/switch-set',
      data,
    })
  },
  // staing
  fetchStakingList(params) {
    return http.get({
      url: '/financial-admin/staking/list',
      params,
    })
  },
  fetchStakingSwitchConf() {
    return http.get({
      url: '/financial-admin/staking/switch-conf',
    })
  },

  fetchStakingSwitchSet(data) {
    return http.post({
      url: '/financial-admin/staking/switch-set',
      data,
    })
  },

  fetchStakingStatusSet(data) {
    return http.post({
      url: '/financial-admin/staking/status-set',
      data,
    })
  },

  fetchStakingSubmit(data) {
    return http.post({
      url: '/financial-admin/staking/submit',
      data,
    })
  },

  fetchStakingDetail(params) {
    return http.get({
      url: '/financial-admin/staking/detail',
      params,
    })
  },
  fetchStakingOrderList(data) {
    return http.get({
      url: '/financial-admin/staking/order/history',
      data,
    })
  },
  fetchStakingOrderAgg(params) {
    return http.get({
      url: '/financial-admin/staking/order/agg',
      params,
    })
  },
  fetchStakingBuy(data) {
    return http.post({
      url: '/financial-admin/staking/buy',
      data,
    })
  },
  fetchStakingSwitchOff(data) {
    return http.post({
      url: '/financial-admin/staking/system-switch-off',
      data,
    })
  },
  fetchStakingSwitchOn(data) {
    return http.post({
      url: '/financial-admin/staking/system-switch-on',
      data,
    })
  },

  fetchStakingOutSwitchOff(data) {
    return http.post({
      url: '/financial-admin/staking/out-switch-off',
      data,
    })
  },
  fetchStakingOutSwitchOn(data) {
    return http.post({
      url: '/financial-admin/staking/out-switch-on',
      data,
    })
  },
  fetchStakingExportOrder(params) {
    return http.get({
      url: '/financial-admin/staking/export-order',
      params,
    })
  },
  fetchUpload(data) {
    return http.post({
      url: '/financial-admin/file/upload',
      data,
      dataType: 'file',
    })
  },
  fetchCoinList() {
    return http.get({
      url: '/financial-admin/config/coin-list',
    })
  },
}
